import React from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/scss/modal-video.scss"
import PropTypes from 'prop-types';

const ModalVideoCmp = ({videoId, channel, onClose, isOpen}) => {

  return (
    <ModalVideo
        channel={channel}
        videoId={videoId}
        isOpen={isOpen}
        onClose={onClose}
      />
  );
}

ModalVideoCmp.propTypes = {
  channel: PropTypes.string,
  videoId: PropTypes.string,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default ModalVideoCmp;